import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { guardArray } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import type { TagesschauResponse } from "@msuite/utils/types";
import { CommandNewsCard } from "./command-news-card";

export function CommandNews() {
	const { t } = useTranslation();

	/** Query */
	const { data: news, dataUpdatedAt } = useQuery({
		queryKey: ["news"],
		queryFn: async () => {
			const response = await fetch("https://www.tagesschau.de/api2u/homepage", {
				method: "GET",
			});
			const json = (await response.json()) as TagesschauResponse;
			return json.news;
		},
		refetchInterval: 1_000 * 60 * 10,
	});

	const lastUpdateAt = moment(dataUpdatedAt).longFormat();

	/** Render */
	return (
		<div className="p-0! overflow-hidden gap-4 v-stack min-h-0 overflow-hidden">
			<div className="h-stack px-4 py-2">
				{t("general_fields.updated_at")}: {lastUpdateAt}
			</div>
			{guardArray(news)
				.slice(0, 25)
				.map((news) => (
					<CommandNewsCard
						key={news.sophoraId}
						news={news}
					/>
				))}
		</div>
	);
}
